export default __webpack_public_path__ + "static/media/Enrollment.767bd560.png";